export const menuItems = ref<{ label: string; icon: string; command: () => void }[]>([])
